import http, { API_BASE, getTokenPayload } from './http'
import axios from 'axios';

// --- Helpers pour l'affichage ---

export function imageUrl(s) {
  if (!s) return 'https://via.placeholder.com/800x450?text=Locapiol'
  if (/^https?:\/\//i.test(s)) return s
  if (s.startsWith('/images/')) return `${API_BASE}${s}`
  return `${API_BASE}/api/Room/images/${encodeURIComponent(s)}`
}

// --- Appels API ---

export async function searchRooms(params = {}, { signal } = {}) {
  const { data } = await http.get('/api/Room/filter', { params, signal })
  return data
}

export async function getMyRooms(hostId, { pageNumber = 1, pageSize = 60 } = {}) {
  let hid = hostId
  if (!hid) {
    const p = getTokenPayload()
    hid = p?.nameid || p?.sub || p?.userId || p?.uid
  }
  try {
    const { data } = await http.get('/api/Room/by-host', { params: { hostId: hid, pageNumber, pageSize } })
    return Array.isArray(data) ? data : (data.items ?? [])
  } catch (e) {
    const { data } = await http.get('/api/Room/filter', { params: { hostId: hid, pageNumber, pageSize } })
    return Array.isArray(data) ? data : (data.items ?? [])
  }
}

export async function getRoomById(id) {
  const { data } = await http.get(`/api/Room/${id}`)
  return data
}

export async function getEquipmentOptions() {
  const { data } = await http.get('/api/Room/equipment')
  return (Array.isArray(data) ? data : []).map(e => ({
    id: e.id ?? e.equipmentId ?? e.equipmentID ?? e.uid ?? e.value,
    name: e.name ?? e.label ?? e.title,
  })).filter(x => x.id != null)
}

export async function getRoomEquipments(roomId) {
  try {
    const res = await axios.get(`${API_BASE}/api/Room/equipment/${roomId}`);
    return res.data;
  } catch (error) {
    console.error("Erreur chargement équipements:", error);
    return []; 
  }
}

// --- Helpers pour la sauvegarde (FormData) ---

const toISO = (d) => {
  if (!d) return undefined
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return new Date(d + 'T00:00:00').toISOString()
  const dd = new Date(d); return isNaN(dd.getTime()) ? undefined : dd.toISOString()
}

const toNum = (v) => { 
  if (v === '' || v === null || v === undefined) return undefined;
  const n = Number(v); 
  return Number.isFinite(n) ? n : undefined 
}

// --- CORRECTION MAJEURE ICI ---
// On envoie uniquement la clé simple. Le backend .NET préfère recevoir 
// plusieurs fois 'EquipmentIds' plutôt que 'EquipmentIds[0]'
const appendArray = (fd, key, arr) => {
  if (!Array.isArray(arr) || !arr.length) return
  arr.forEach(v => fd.append(key, v)) 
}

function fillCommon(fd, room) {
  const add = (k, v) => { 
    if (v !== undefined && v !== null && v !== '') {
      fd.append(k, v) 
    }
  }

  add('Name', room.name)
  add('Type', room.type)
  add('Description', room.description)
  add('AvailableFrom', toISO(room.availableFrom))
  add('AvailableTo', toISO(room.availableTo))
  
  // Conversion explicite en String pour éviter les bugs de décimales
  add('Latitude', room.latitude?.toString())
  add('Longitude', room.longitude?.toString())

  add('Price.Unit', room.priceUnit)
  add('Price.Amount', room.priceAmount?.toString())
  add('Price.Currency', room.priceCurrency || 'XAF')

  add('Location.Country', room.locationCountry)
  add('Location.City', room.locationCity)
  add('Location.District', room.locationDistrict)
  add('Location.Street', room.locationStreet)

  if (Array.isArray(room.images)) {
    room.images.forEach(f => f && fd.append('Images', f))
  }

  // Envoi des IDs d'équipement corrigé
  if (Array.isArray(room.equipmentIds)) {
    const validIds = room.equipmentIds.map(id => parseInt(id, 10)).filter(n => !isNaN(n));
    appendArray(fd, 'EquipmentIds', validIds);
  }

  // Envoi des infos numériques (MaxGuests, Lits, etc.)
  add('RoomsCount', room.roomsCount?.toString())
  add('SizeInSquareMeters', room.sizeInSquareMeters?.toString())
  add('MaxGuests', room.maxGuests?.toString())
  add('BedCount', room.bedCount?.toString())
  
  if (room.hasPrivateBathroom !== undefined) add('HasPrivateBathroom', room.hasPrivateBathroom)
  if (room.isNegotiable !== undefined) add('IsNegotiable', room.isNegotiable)
  
  add('CleaningFee', room.cleaningFee?.toString())
  add('MinimumStayInNights', room.minimumStayInNights?.toString())
  add('MaximumStayInNights', room.maximumStayInNights?.toString())
}

export async function createRoomMultipart(room) {
  const fd = new FormData()
  fillCommon(fd, room)
  const { data } = await http.post('/api/Room', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export async function updateRoomMultipart(id, room) {
  const fd = new FormData()
  fillCommon(fd, room)
  fd.append('RoomID', id); // Important pour l'update
  const { data } = await http.put(`/api/Room/${id}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
  return data
}

export async function deleteRoom(id) {
  await http.delete(`/api/Room/${id}`)
}